<template>
  <div>
    <!-- <el-card shadow="always">
      <div class="side-frame">
        <span style="font-size: 14px; color: #606266">基本信息</span>
      </div>

      <edit-form
        ref="editForm"
        :disabled="isDisableEditForm"
        :params="params"
      />
      <div class="d-flex justify-content-end mb-2">
        <el-button
          v-if="!isDisableEditForm"
          type="primary"
          size="small"
          @click="$refs.editForm.save()"
          >保存</el-button
        >
      </div>
    </el-card> -->
  </div>
</template>
<script>
import EditForm from '../components/edit-form'
export default {
  name: 'master-icechopsdetail',
  components: {
    EditForm,
  },
  computed: {
    params() {
      return this.$route.params
    },
    pageType() {
      return this.params.pageType
    },
    // 是否禁用表单
    isDisableEditForm() {
      return this.pageType === 'detail'
    },
  },
}
</script>
<style lang="scss" scoped>
.side-frame {
  padding: 1px 10px;
  border-left: 3px solid $color-primary;
  margin: 15px 0;
}
</style>
